import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import { FAIcon } from './fa-icon';

export const UserIcon = ({
  size,
  width,
}: { width?: string } & Omit<FontAwesomeIconProps, 'icon'>) => (
  <FAIcon icon={faUser} size={size} width={width} />
);
